module.exports = __webpack_public_path__ + "fonts/fa-solid-900.5011b03.eot";